<template>
  <div class="page page-preview">
    <div class="title">
      请仔细核对信息
    </div>
    <div class="preview-info" style="margin-top: -80px;">
      <div class="date">
        <div class="label">
          预约办理日期
        </div>
        <div class="value">{{ planInfo.planDate }}</div>
      </div>
      <div class="time">
        <div class="label">
          预约办理时段
        </div>
        <div class="value">{{ planInfo.startTime }} - {{ planInfo.endTime }}</div>
      </div>
      <div class="time">
        <div class="label">
          预约咨询电话
        </div>
        <div class="value">59389835</div>
      </div>
      <div class="address">
        <div class="label">
          预约办理地点
        </div>
        <div class="value">
          西城区车公庄大街9号院1号楼2门701室
        </div>
      </div>
    </div>
    <div class="service-list">
      <div class="tip">请选择需要办理的业务</div>
      <van-checkbox-group v-model="selectService">
        <van-cell-group>
          <van-cell
              v-for="(service, index) in serviceList"
              clickable
              :key="service.id"
              :title="service.title"
              @click="toggle(index)"
          >
            <template #title>
              <span class="custom-title" style="color: #1989fa;">{{ service.title }}</span>
            </template>
            <template #right-icon>
              <span v-if="service.requirement" class="show-requirement"
                    @click.stop="showRequirement(service)">办理要求</span>
              <van-checkbox :name="service.id" ref="checkboxes">
              </van-checkbox>
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </div>
    <!--    <template v-if="selectServiceList.length > 0">-->
    <!--      <div class="divider"></div>-->
    <!--      <div class="requirement">-->
    <!--        <div>业务要求</div>-->
    <!--        <div class="requirement-item" v-for="service in selectServiceList">-->
    <!--          <div class="item-title">{{ service.title }}</div>-->
    <!--          <div class="item-info">{{ service.requirement || '无' }}</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </template>-->
    <div class="notice">
      <div>预约须知</div>
      1、【取号】建议办理业务人员当天预约当天时间前取号，上午取号时间为8:30至11:15，下午取号时间为13:30至16:45;预约未取号记为爽约。
      <br/>
      2、【退号】办理业务当日00:00点前可在线退号。
      <br/>
      3、 预约成功后，请按时来卫人公司取号办理业务。
      <br/>
      4、办理业务请根据预约提示带好个人资料，刷本人身份证实名办理业务。
      <br/>
      5、如遇突发疫情情况，您预约的号源有可能会因疫情防控要求被替换或取消，特殊时期请您谅解。
      <br/>
      6、如有其他问题可咨询前台电话59389835。
    </div>
    <div class="confirm-action">
      <van-button :disabled="selectService.length === 0"
                  @click="handleClickConfirm" round color="#1989fa"
                  style="width: 100%">提交预约申请
      </van-button>
    </div>
    <van-popup v-model="isShowPop" round>
      <div class="prview-content">
        <div class="requirement-title">
          {{ service.title }}-办理要求
        </div>
        <div class="content" v-html="service.requirement">
        </div>
        <van-button @click="isShowPop = false" round type="info" style="margin-top: 10px;height: 40px;">知道了</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import mixinLoad from '@/mixin/mixin-load.js';
import {Dialog} from 'vant';
import {serviceList, previewPlan, requestApply} from '@/api/reservation'

export default {
  mixins: [mixinLoad],
  data() {
    return {
      service: {},
      isShowPop: false,
      serviceList: [],
      selectService: [],
      planInfo: {},
    };
  },
  computed: {
    selectServiceList() {
      return this.selectService.map((id) => {
        return this.serviceList.find((item) => id === item.id)
      })
    }
  },
  methods: {
    showRequirement(service) {
      this.service = service;
      this.isShowPop = true;
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    handleClickConfirm() {
      Dialog.confirm({
        title: '温馨提示',
        message: '确认提交当前预约申请？',
      })
          .then(() => {
            const loading = this.showLoading();
            requestApply({planUuid: this.planUuid, serviceIdList: this.selectService}).then((rep) => {
              loading.close();
              if (rep.code === 1) {
                Dialog.alert({
                  title: '温馨提示',
                  message: '提交成功',
                }).then(() => {
                  this.$router.replace({
                    path: '/reservation-my'
                  });
                })
              } else {
                Dialog.alert({
                  title: '温馨提示',
                  message: rep.msg,
                })
              }
            }).catch(() => {
              loading.close();
            })
          })
          .catch(() => {
            // on cancel
          });
    },
    loadData() {
      serviceList().then((rep) => {
        this.serviceList = rep.data;
      })
      const loading = this.showLoading();
      previewPlan({uuid: this.planUuid}).then((rep) => {
        loading.close();
        this.planInfo = rep.data;
      }).catch(() => {
        loading.close();
      })
    }
  },
  created() {
    this.planUuid = this.$route.query.uuid;
    this.loadData();
  }
};
</script>

<style scoped>
.page-preview {
  min-height: 100vh;
}

.page-preview >>> .van-checkbox-group {
  background: #FFFFFF;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin: 12px;
}

.van-cell, .van-cell-group {
  background: none;
}

.title {
  background: #408CF8;
  color: #fff;
  padding: 16px;
  height: 100px;
}

.divider {
  width: 100%;
  height: 10px;
}

.preview-info {
  background: #FFFFFF;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin: 12px;
  padding: 5px;
}

.preview-info > div {
  margin: 5px;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
}

.preview-info .label {
  width: 100px;
}

.preview-info .value {
  text-align: right;
}

.preview-info .date .value {
  color: #1989fa;
  font-weight: 800;
}

.notice, .requirement {
  font-size: 14px;
  padding: 10px 16px;
  line-height: 26px;
  margin: 12px 12px 80px 12px;
  background: #FFFFFF;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.requirement {
  margin-bottom: 0px;
}

.confirm-action {
  padding: 10px;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
}

.service-list {
}

.service-list .tip {
  font-size: 15px;
  margin: 0 0 5px 15px;
  color: #1989fa;
}

.requirement-item .item-title {
}

.requirement-item .item-info {
  font-size: 13px;
}

.show-requirement {
  margin-right: 20px;
  font-size: 12px;
}

.prview-content {
  min-width: 80vw;
  height: 80vh;
  padding: 16px 10px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.prview-content .content {
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  font-size: 14px;
  line-height: 22px;
  overflow-y: scroll;
  flex-grow: 1;
  white-space: pre-wrap;
}

.requirement-title {
  text-align: center;
  font-size: 16px;
}
</style>
